import QuestionInformationItem from "components/Blocks/QuestionInformationItem/QuestionInformationItem";

export default QuestionInformationItem;
